import { render, staticRenderFns } from "./childTicket.vue?vue&type=template&id=47706db7&scoped=true&"
import script from "./childTicket.vue?vue&type=script&lang=js&"
export * from "./childTicket.vue?vue&type=script&lang=js&"
import style0 from "./childTicket.vue?vue&type=style&index=0&id=47706db7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47706db7",
  null
  
)

export default component.exports